<template>
  <div
    id="pageBingo"
    class="d-flex flex-column main-bingo"
    :class="{ 'h-100': !isHauteurPageAutomatique }"
  >
    <div>
      <vue-headful
        :title="metaData.title"
        :description="metaData.description"
        :keywords="metaData.keywords"
        :image="metaData.metaOGImage"
        :url="metaUrl"
        :head="{
          'meta[name=robots]': { content: metaData.metaNoIndex },
          'link[hreflang=en-ca]': { href: pathAnglais },
          'link[hreflang=fr-ca]': { href: pathFrancais },
          'link[rel=apple-touch-icon]': { type: 'image/png' },
          'link[rel=icon]': { type: 'image/png' },
        }"
      />

      <div class="w-100 h-100">
        <BingoMenu />
        <main class="d-flex align-items-center h-100 px-0 overflow-hidden">
          <EditableArea
            v-if="content.main"
            :key="componentKey"
            class="w-100 h-100"
            :content="content.main"
          />
        </main>
        <ModaleConfirmationCICL />
        <Heritage v-if="!mixinEnvironnement_inEditor" :content="contentHeritageModalNewsletter" />
        <Heritage v-if="!mixinEnvironnement_inEditor" :content="contentCatfish" />
        <Heritage v-if="!mixinEnvironnement_inEditor" :content="contentNotifications" />
        <Heritage v-if="!mixinEnvironnement_inEditor" :content="contentBanniereLaterale" />
      </div>

      <!-- Scroll-to-top button // all platforms except 'samsungbrowser' -->
      <b-link id="return-to-top" @click.prevent="mixinHelpers_smoothScrollTo()">
        <svg-icon class="icone-fleche rotation90" icon-name="fleche-lien-gauche"></svg-icon>
      </b-link>
      <footer
        v-if="isPiedDePageVisible"
        id="footer"
        class="p-0"
        :class="$isMobile ? 'compteFonce' : content.themePiedDePage"
      >
        <Heritage :key="componentKey" class="piedDePage" :content="contentHeritagePiedDePage" />
      </footer>
    </div>
  </div>
</template>

<script>
import vueHeadful from 'vue-headful';
import { mapGetters } from 'vuex';
import { EditableArea } from '@/vue-editor';
import { bus } from '@/main';

import BingoMenu from '@/components/bingo/BingoMenu';
import ModaleConfirmationCICL from '@/components/bingo/modals/ModaleConfirmationCICL';
import Heritage from '@/components/base/Heritage';

import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';
import { mixinHelpers } from '@/mixins/mixinHelpers';

import { inMgnl } from '@/helpers/AppHelpers';
import { stripAllHtmlTag } from '@/helpers/StringHelpers';

import session from '@/services/api/compte/session';

export default {
  name: 'Bingo',
  components: {
    EditableArea,
    BingoMenu,
    Heritage,
    ModaleConfirmationCICL,
    vueHeadful,
  },
  mixins: [mixinEnvironnement, mixinHelpers],
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  data() {
    return {
      contentHeritagePiedDePage: { lienInterne: process.env.VUE_APP_JEL_NOEUD_CASINO_PIEDDEPAGE },
      contentHeritageModalNewsletter: {
        lienInterne: process.env.VUE_APP_JEL_NOEUD_MODALNEWSLETTER,
      },
      contentCatfish: {
        lienInterne: process.env.VUE_APP_JEL_NOEUD_BINGO_CATFISH,
      },
      contentNotifications: {
        lienInterne: process.env.VUE_APP_JEL_NOEUD_BINGO_NOTIFICATIONS,
      },
      contentBanniereLaterale: {
        lienInterne: process.env.VUE_APP_JEL_NOEUD_BINGO_BANNIERELATERALE,
      },
      metaUrl: document.URL,
      // componentKey est utilisé pour raffraîchir les composants lors d'une ouverture de session
      componentKey: 0,
      metaData: {
        title: '',
        description: '',
        keywords: '',
        metaNoIndex: '',
        metaOGImage: '',
      },
      // modaleNewsletter: {
      //   titre: null,
      //   message: null,
      //   moreInfo: null,
      //   accepterRecevoirMessage: null,
      //   optIn: null,
      // },
      // modaleNewsletterConfirmation: {
      //   titre: null,
      //   message: null,
      // },
      // modaleNewsletterErreur: {
      //   titre: null,
      //   message: null,
      // },
      // message: null,
      // messageErreur: {
      //   idHTML: 'erreurNewsletter',
      //   idHTMLContenu: 'contenuErreur',
      // },
      pathFrancais: '',
      pathAnglais: '',
    };
  },
  computed: {
    ...mapGetters({
      getIsMenuGaucheOuvert: 'menu/getIsMenuGaucheOuvert',
    }),
    getStatusMenuGauche() {
      if (this.getIsMenuGaucheOuvert != null) return this.getIsMenuGaucheOuvert;
      return this.$mq == 'xl' || this.$mq == 'xxl';
    },
    isNavigatorUserAgentSamsung() {
      return navigator.userAgent.toLowerCase().indexOf('samsungbrowser') > -1;
    },
    isPiedDePageVisible() {
      return (
        (!this.content.themePiedDePage || this.content.themePiedDePage != 'invisible') &&
        !this.mixinEnvironnement_inAppMobile
      );
    },
    isHauteurPageAutomatique() {
      return this.content.hauteurPageAutomatique || this.jel_isIPhoneOrIPod();
    },
    // state() {
    //   return this.subscribeNewsletter != false;
    // },
    // // State du checkbox de la modale MAS en direct
    // subscribeNewsletter: {
    //   get() {
    //     return this.modaleNewsletter.optIn;
    //   },
    //   set(value) {
    //     this.modaleNewsletter.optIn = value;
    //     this.message = null;
    //   },
    // },
    // enSavoirPlus() {
    //   return {
    //     texte: this.$i18n.t('casino.newsletter.modale.moreInfo'),
    //     type: 'lienSecondaire',
    //     lien: {
    //       field: 'lienExterne',
    //       lienExterne: this.$i18n.t('casino.newsletter.modale.urlEnSavoirPlus'),
    //     },
    //     classeCSS: 'd-flex d-inline-flex',
    //   };
    // },
  },
  activated() {
    document.body.scrollTop = 0;
  },
  mounted() {
    document.addEventListener('ejEventLogin', this.ejLoginEventListener);

    // TODO: Revoir le chargement du css pour ne pas qu'il soit constament ré-exécuté (à essayer dans le created mais idéalement revoir le chargement à la source)
    // Empêcher le logo Loto-Québec de la barre portail de s'afficher momentanément pleine grandeur
    if (!inMgnl) {
      const style = document.createElement('link');
      style.rel = 'stylesheet';
      style.type = 'text/css';
      style.href = '/mel/.resources/lq-entete-commun/webresources/css/barreportail-app.css?v=210';
      document.head.append(style);
    }

    // Même dans une page Bingo, on peut devoir afficher des informations Casino
    this.$store.commit('produitCollection/INIT');
    this.$store.commit('produitCasino/INIT');
    // this.$store.commit('cedTable/INIT');
    this.$store.commit('progressif/INIT');
    this.$store.commit('integrateur/INIT');
    this.$store.commit('fournisseur/INIT');
    this.$store.commit('etiquette/INIT');

    document.body.scrollTop = 0; // forcer la page à charger en haut de page pour régler un problème sur mobile

    this.busEmitNouvellePage();

    bus.$on('urlAutreLangue', (url) => {
      this.miseAJourMetaLien(url);
    });

    const uri = this.$store.getters['routes/getPathAutreLangue'](window.location.pathname.slice(3));
    this.miseAJourMetaLien(uri);
    this.miseAjourMetaInfo(this.content);

    // Lors du premier click dans le vide (body) la page remonte automatiquement au top, ceci est une patch pour conserver le scroll au bon endroit
    document.body.addEventListener('click', this.fixFirstClickScrollTop);

    // permet le fonctionnement de window.scroll pour le go top
    document.getElementsByTagName('html')[0].style.overflow = 'visible';

    if (!this.isNavigatorUserAgentSamsung) {
      window.addEventListener('scroll', this.returnToTopScroll);
    }
  },
  beforeDestroy() {
    document.removeEventListener('ejEventLogin', this.ejLoginEventListener);
    this.removeInitialClickListener();
    if (!this.isNavigatorUserAgentSamsung) {
      window.removeEventListener('scroll', this.returnToTopScroll);
    }
  },
  methods: {
    ejLoginEventListener() {
      // componentKey est utilisé pour raffraîchir les composants lors d'une ouverture de session
      // Réf: https://michaelnthiessen.com/force-re-render/
      this.componentKey++;
      if (session.sessionEstOuverte()) {
        this.$store.dispatch('preferences/getPreferences');
      }
    },
    busEmitNouvellePage() {
      const self = this;
      bus.$emit('NouvellePageMounted', {
        afficherNavigation: self.content.afficherNavigation == 'true',
        theme: self.content.theme,
        themeLogoNav: self.content.themeLogoNav,
      });
    },
    miseAJourMetaLien(url) {
      this.pathFrancais = this.metaUrl.includes('/fr/')
        ? this.metaUrl
        : window.location.origin + url;
      this.pathAnglais = this.metaUrl.includes('/en/')
        ? this.metaUrl
        : window.location.origin + url;
    },
    miseAjourMetaInfo(info) {
      this.metaData.title = `${info.title ? info.title : ''} | Loto-Québec`;
      this.metaData.description = info.description ? stripAllHtmlTag(info.description) : '';
      this.metaData.keywords = info.keywords ? info.keywords : '';
      this.metaData.metaNoIndex = info.noindex == 'true' ? 'noindex' : 'index, follow';
      this.metaData.metaOGImage = info.metaOGImage ? this.jel_getFichierSrc(info.metaOGImage) : '';
    },
    fixFirstClickScrollTop() {
      const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

      if (isChrome) {
        const scrolled = document.body.scrollTop;

        document.body.scroll({
          top: scrolled,
          behavior: 'smooth',
        });
      }
      this.removeInitialClickListener();
    },
    removeInitialClickListener() {
      document.body.removeEventListener('click', this.fixFirstClickScrollTop);
    },
    returnToTopScroll() {
      if (window.scrollY >= 500) {
        document.getElementById('return-to-top').style.display = 'block';
      } else {
        document.getElementById('return-to-top').style.display = 'none';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
}

main {
  width: inherit;
}

#return-to-top {
  position: fixed;
  z-index: 99;
  bottom: 60px;
  right: 20px;
  background: #073159;
  background: #336da6;
  width: 40px;
  height: 40px;
  display: block;
  text-decoration: none;
  border-radius: 35px;
  display: none;
  transition: all 0.5s ease;
  opacity: 0.75 !important;
  text-align: center;
  .icone-fleche {
    color: #a1dbd2;
    color: white;
    margin: 0;
    position: relative;
    width: 25%;
    top: 0;
    left: 0;
    font-size: 2.4rem;
    transition: all 0.3s ease;
  }
  &:hover {
    background: rgb(51, 109, 166);
    opacity: 1 !important;
    .icone-fleche {
      top: -4px;
    }
  }
}
</style>
